import { toHan, toZen } from 'jaconv'

export function syntaxHighlight(str, keywords, className = 'highlight') {
  if (keywords.length === 0) return str
  const zenkaku = keywords.map(keyword => toZen(keyword))
  const hankaku = keywords.map(keyword => toHan(keyword))
  const regexp = new RegExp([...zenkaku, ...hankaku].join('|'), 'gi')
  return str.replace(regexp, `<span class="${ className }">$&</span>`)

}
